import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";

/**
 * Initializes the customer logos slider using Swiper.
 */
export const initCustomersSlider = (): void => {
  const sliderElements = document.querySelectorAll<HTMLElement>(
    ".customers-slider .swiper"
  );

  if (sliderElements.length === 0) {
    return;
  }

  sliderElements.forEach((sliderElement) => {
    new Swiper(sliderElement, {
      modules: [Autoplay],
      /*       loop: true, */
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      slidesPerView: 2,
      spaceBetween: 30,
      breakpoints: {
        // when window width is >= 768px (tablet)
        768: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        // when window width is >= 1024px (desktop)
        1024: {
          slidesPerView: 5,
          spaceBetween: 50,
        },
      },
    });
  });

  console.log("[Sliders] Customers Slider initialized.");
};
